/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Popover,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { navigate } from 'gatsby';
import StyledButton from '../atoms/StyledButton';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'none',
    '@media screen and (max-width: 1290px)': {
      display: 'block',
    },
  },
  drawer: {
    background: theme.palette.primary.alpha,
    boxShadow: '0px 30px 70px rgba(58, 53, 104, 0.102)',
  },
  list: {
    '& .MuiListItem-button': {
      borderRadius: '10px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  divider: {
    width: '70%',
    height: '1px',
    transform: 'translateX(-50%)',
    margin: '20px 0 20px 50%',
    backgroundColor: theme.palette.action.disabledBackground,
  },
  paper: {
    backgroundColor: theme.palette.secondary.contrastText,
    border: 'none',
    outline: 0,
    padding: '50px 21px 32px',
    right: '21px !important',
    left: '21px !important',
    top: '65px !important',
    maxHeight: 'max-content !important',
  },
  buttonClose: {
    position: 'absolute',
    top: '15px',
    right: '17px',
    zIndex: '100',
  },
  icon: {
    color: theme.palette.primary.main,
    fontsize: '30px !important',
  },
  customerArea: {
    '& .MuiListItemIcon-root': {
      justifyContent: 'flex-end',
    },
    '& .up svg': {
      transform: 'rotate(180deg)',
      transition: '0.1s',
    },
    '& .down svg': {
      transform: 'rotate(0deg)',
      transition: '0.1s',
    },
  },
}));

/**
 *
 * @param {{ open: boolean, setOpen: (open: boolean)=>void }} props
 */
export default function DropDownMenuMobile({ open, setOpen }) {
  const classes = useStyles();
  const [ferramentasOpen, setFerramentasOpen] = useState(false);

  const renderListItem = (text, url, iconAlt, icon, color, newTab) => (
    <ListItem
      button
      component="a"
      href={url}
      // undefined nao renderiza o atributo: sem newTab, mantem o
      // comportamento atual (navega na mesma aba).
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noopener noreferrer' : undefined}
      style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', borderBottom: '1px solid #66647A', borderRadius: 0, padding: '12px 16px',
      }}
    >
      {icon && (
        <ListItemIcon>
          <img src={icon} alt={iconAlt} />
        </ListItemIcon>
      )}
      <ListItemText
        primary={text}
        primaryTypographyProps={{
          style: {
            color, fontSize: '12px', fontWeight: '700', textTransform: 'uppercase',
          },
        }}
      />
    </ListItem>
  );

  return (
    <Popover
      className={classes.root}
      classes={{
        paper: classes.paper,
      }}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      open={open}
      onClose={() => setOpen(false)}
      variant="temporary"
    >
      <IconButton
        style={{ color: '#0E599E' }}
        className={classes.buttonClose}
        onClick={() => setOpen(false)}
      >
        <Close />
      </IconButton>
      <List className={classes.list}>
        {renderListItem('Trocar de contador', '/trocar-contador/')}
        {renderListItem('Quanto custa?', '/quanto-custa/')}
        {renderListItem('Soluções', '/solucoes/')}
        {renderListItem('Blog', 'https://conube.com.br/blog/')}
        <ListItem
          button
          onClick={() => setFerramentasOpen(!ferramentasOpen)}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', borderBottom: '1px solid #66647A', borderRadius: 0, padding: '12px 16px',
          }}
        >
          <ListItemText
            primary="FERRAMENTAS"
            primaryTypographyProps={{
              style: {
                fontSize: '12px', fontWeight: '700', textTransform: 'uppercase',
              },
            }}
          />
        </ListItem>
        <Collapse in={ferramentasOpen} timeout="auto" unmountOnExit style={{ width: '100%' }}>
          {renderListItem('Consulta de CNAE', 'https://www.cnae-simples.com.br/')}
          {renderListItem('Calculadora de Impostos PF x PJ', '/calculadora-impostos-clt-pj/')}
          {renderListItem('Calculadora Salário CLT x PJ', '/calculadora-salario-clt-pj/')}
        </Collapse>
        {renderListItem('Paralegal', '/servicos-paralegais/', undefined, undefined, undefined, true)}
        <ListItem
          button
          component="a"
          href={process.env.GATSBY_DYNAMO_LOGIN}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', borderBottom: '1px solid #66647A', borderRadius: 0, padding: '12px 16px',
          }}
        >
          <ListItemText
            primary="MINHA CONTA"
            primaryTypographyProps={{ style: { color: '#0093F5', fontSize: '12px', fontWeight: '700' } }}
          />
        </ListItem>
        <StyledButton
          text="ABRIR EMPRESA GRÁTIS"
          variant="contained"
          color="primary"
          height="50px"
          style={{
            textWrap: 'nowrap',
            width: 'fit-content',
            backgroundColor: '#0093F5',
            marginTop: '24px',
          }}
          onClick={() => {
            navigate('/abrir-empresa/');
          }}
        />
      </List>
    </Popover>
  );
}
